import styled, { css } from "styled-components";
import { Checkbox as AntdCheckbox } from "antd";
import { CHECKBOX_SIZE, DisplaySize, FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

const getSize = (displaySize?: DisplaySize) =>
  displaySize || DISPLAY_SIZES.SMALL;

const getCheckboxScale = (boxSize: number) => boxSize / 16;

export const StyledCheckbox = styled(AntdCheckbox)<{
  $displaySize?: DisplaySize;
}>`
  display: inline-flex;
  align-items: center;
  line-height: 1;

  ${({ $displaySize }) => {
    const size = getSize($displaySize);
    const boxSize = CHECKBOX_SIZE[size];
    const fontSize = FONT_SIZE[size];
    const scale = getCheckboxScale(boxSize);
    const checkWidth = 5.71428571 * scale;
    const checkHeight = 9.14285714 * scale;
    const indeterminateSize = 8 * scale;

    return css`
      .ant-checkbox {
        top: 0;
        line-height: 1;
      }

      .ant-checkbox-inner {
        width: ${boxSize}px !important;
        height: ${boxSize}px !important;
        border-radius: 2px;

        &::after {
          width: ${checkWidth}px;
          height: ${checkHeight}px;
          border-width: ${Math.max(1, 2 * scale)}px;
        }
      }

      .ant-checkbox-indeterminate .ant-checkbox-inner::after {
        width: ${indeterminateSize}px;
        height: ${indeterminateSize}px;
      }

      .ant-checkbox + span {
        font-size: ${fontSize};
        padding-left: 8px;
        line-height: 1.2;
      }
    `;
  }}
`;
